import { Grid, Skeleton } from "@mui/material"
import React from "react"

export default function SelectorWithSkeleton({ isLoading, SelectorComponent, condition = true, xs = 6 }) {
	if (!condition) return null
	
	return <Grid item xs={xs}>
		{isLoading ? <Skeleton variant="rectangular" width="100%" height={40}/> : <SelectorComponent/>}
	</Grid>
}